import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Home from '@/pages/Home'
import Attendance from '@/pages/Attendance'
import Shift from '@/pages/Shift'
import ShiftAdmin from '@/pages/ShiftAdmin'
import Notices from '@/pages/Notices'
import Salary from '@/pages/Salary'
import SalaryAdmin from '@/pages/SalaryAdmin'
import StaffAdmin from '@/pages/StaffAdmin'
import './App.css'

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/attendance" element={<Attendance />} />
          <Route path="/shift" element={<Shift />} />
          <Route path="/admin/shift" element={<ShiftAdmin />} />
          <Route path="/notices" element={<Notices />} />
          <Route path="/salary" element={<Salary />} />
          <Route path="/salary-admin" element={<SalaryAdmin />} />
          <Route path="/staff-admin" element={<StaffAdmin />} />
        </Routes>
      </div>
    </Router>
  )
}

export default App